// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y9X73","type":"styles_type__2Fa5Y","choices":"styles_choices__1_gc9"};